import React from "react";

// auth
import ConfirmMail from "../views/dashboard/auth/confirm-mail";
import LockScreen from "../views/dashboard/auth/lock-screen";
import Recoverpw from "../views/dashboard/auth/recoverpw";
import SignIn from "../views/dashboard/auth/sign-in";
import Forgot from "../views/dashboard/auth/forgot";
import ForgotPassword from "../views/dashboard/auth/forgotpassword";
import SignUp from "../views/dashboard/auth/sign-up";

// errors
import Error404 from "../views/dashboard/errors/error404";
import Error500 from "../views/dashboard/errors/error500";

//extrpages
import Maintenance from "../views/dashboard/extrapages/maintenance";
import ComingSoon from "../views/dashboard/extrapages/comingsoon";
import ScannedQrcDetails from "../views/dashboard/app/CriticalQrc/ScannedQrcDetails";
import ScannedQrcDetailsLostFound from "../views/dashboard/app/LostFoundQrc/ScannedQrcDetailsLostFound";
import ScannedQrcAddDetails from "../views/dashboard/app/LostFoundQrc/ScannedQrcAddDetails";
import PostTemplate from "../views/dashboard/PostTemplate";
import EventTemplate from "../views/dashboard/EventTemplate";
import QRCNotActivePage from "../views/dashboard/app/Critical/QRCNotActivePage";
import ExampleComponent from "../views/Lost&Found/ExampleComponent";
import LostItemPage from "../views/Lost&Found/LostItemPage";
import PaymentSuccess from "../components/Payment/PaymentSuccess";
import PaymentFailed from "../components/Payment/PaymentFailed";
import PaymentQRC from "../components/Payment/PaymentQRC";
import PlanSwitchSuccess from "../components/Payment/PlanSwitchSuccess";
import LocationComponent from "../components/Location/LocationComponent";
import EmergencyContact from "../views/dashboard/extrapages/EmergencyContact";
import QrTemplate from "../views/dashboard/store/QrTemplate";
import VcardTemplate from "../views/dashboard/store/VcardTemplate";
import FileTemplate from "../views/dashboard/store/FileTemplate";
import RecoverAccount from "../views/dashboard/auth/RecoverAccount";



export const SimpleRouter = [
  {
    path: "auth/confirm-mail",
    element: <ConfirmMail />,
  },
  {
    path: "auth/lock-screen",
    element: <LockScreen />,
  },
  {
    path: "auth/recoverpw",
    element: <Recoverpw />,
  },
  {
    path: "auth/sign-in",
    element: <SignIn />,
  },
  {
    path: "auth/sign-up",
    element: <SignUp />,
  }, 
  {
    path: "auth/forgot",
    element: <Forgot />,
  },
  {
    path: "auth/recover-account",
    element: <RecoverAccount />,
  },
  {
    path: "auth/forgotpassword",
    element: <ForgotPassword />,
  },
  // {
  //   path: "critical-qrc-more-details/:qrcid",
  //   element: <ScannedQrcDetails />,
  // },
  {
    path: ":country/CD/:qrcid",
    element: <ScannedQrcDetails />,
  },
  {
    path: "lost-qrc-add-details/:deviceid/:scanId",
    element: <ScannedQrcAddDetails />,
  },
  // {
  //   path: "lost-qrc-more-details/:qrcid",
  //   element: <ScannedQrcDetailsLostFound />,
  // },
  // {
  //   path: ":country/TF/:qrcid",
  //   element: <ScannedQrcDetailsLostFound />,
  // },
  {
    path: ":country/TF/:qrcid",
    element: <LostItemPage />,
  },
  // {
  //   path: "lostitem/:qrcid",
  //   element: <LostItemPage />,
  // },
  {
    path: "locationcomponent",
    element: <LocationComponent />,
  },
    {
    path: ":username/vc/:id",
    element: <VcardTemplate />,
  },
  //   {
  //   path: ":username/vCard/:id",
  //   element: <VcardTemplate />,
  // },
  // {
  //   path: ":username/file/:id",
  //   element: <FileTemplate />,
  // },
  {
    path: ":username/fls/:id",
    element: <FileTemplate />,
  },

  {
    path: ":country/:id",
    element: <QrTemplate />,
  },
  {
    path: ":id",
    element: <QrTemplate />,
  },
  {
    path: "post/:id",
    element: <PostTemplate />,
  },
  {
    path: "event/:id",
    element: <EventTemplate />,
  },
  {
    path: "qrcstatus",
    element: <QRCNotActivePage />,
  },
  {
    path: "checkcomp",
    element: <ExampleComponent />,
  },
  {
    path: "payment-success",
    element: <PaymentSuccess />,
  },
  {
    path: "plan-success-switch",
    element: <PlanSwitchSuccess />,
  },
  {
    path: "payment-qrc/:id",
    element: <PaymentQRC />,
  },
  {
    path: "payment-failed",
    element: <PaymentFailed />,
  },
  {
    path: "errors/error404",
    element: <Error404 />,
  },
  {
    path: "errors/error500",
    element: <Error500 />,
  },
  {
    path: "maintenance",
    element: <Maintenance />,
  },
  {
    path: "emergency-contact",
    element: <EmergencyContact />,
  },
  {
    path: "extra-pages/pages-comingsoon",
    element: <ComingSoon />,
  },
  {
    path: "*",
    element: <Error404 />,
  },
];
